export const SUPPORT_ROLE_LABELS = {
  ROLE_ADMIN: 'Admin',
  ROLE_THERAPY_SUP_L1: 'Therapy Support L1',
  ROLE_THERAPY_SUP_L2: 'Therapy Support L2',
  ROLE_THERAPY_SUP_L3: 'Therapy Support L3',
  ROLE_THERAPIST_ADMIN: 'Therapist Admin',
  ROLE_THERAPIST_SUPERVISOR: 'Therapist Supervisor',
  ROLE_THERAPY_SUPERVISOR: 'Therapy Supervisor',
  ROLE_SCREENER_SUPERVISOR: 'Screener Supervisor',
  ROLE_CLINIC_SUCCESS_ADMIN: 'Clinic Success Admin',
  ROLE_CLINIC_SUCCESS_MANAGER: 'Clinic Success Manager',
  ROLE_CLINIC_ROSTER_ADMIN: 'Clinic Roster Admin',
  ROLE_CLINIC_ROSTER_MANAGER: 'Clinic Roster Manager',
  ROLE_MANAGEMENT: 'Management',
  ROLE_VC_AUDIT_ADMIN: 'VC Audit Admin',
  ROLE_VC_AUDIT_MANAGER: 'VC Audit Manager',
  ROLE_DOCSIDE_ADMIN: 'DocSide Admin',
  ROLE_DOCSIDE_MANAGER: 'DocSide Manager',
}

export const SUPPORT_BOOKINGS_THERAPY_ROLES = [
  'ROLE_THERAPY_SUP_L2',
  'ROLE_THERAPY_SUP_L3',
]

export const SUPPORT_BOOKINGS_REPORT_SUPERVISOR_ROLES = [
  'ROLE_THERAPIST_SUPERVISOR',
  'ROLE_THERAPY_SUPERVISOR',
  'ROLE_SCREENER_SUPERVISOR',
]

export const SUPPORT_BOOKINGS_CLINIC_SUCCESS_ROLES = [
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_CLINIC_SUCCESS_MANAGER',
]

export const SUPPORT_BOOKING_ACTION_CONSULTATION_ROLES = [
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_CLINIC_SUCCESS_MANAGER',
]

export const SUPPORT_BOOKING_ACTION_THERAPY_ROLES = [
  'ROLE_THERAPY_SUP_L2',
  'ROLE_THERAPY_SUP_L3',
]

export const SUPPORT_BOOKINGS_VIEW_ROLES = [
  ...SUPPORT_BOOKINGS_THERAPY_ROLES,
  ...SUPPORT_BOOKINGS_REPORT_SUPERVISOR_ROLES,
  ...SUPPORT_BOOKINGS_CLINIC_SUCCESS_ROLES,
  'ROLE_ADMIN',
]

export const SUPPORT_PAYMENT_LINKS_VIEW_ROLES = [
  'ROLE_THERAPY_SUP_L2',
  'ROLE_THERAPY_SUP_L3',
  'ROLE_CLINIC_SUCCESS_MANAGER',
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_ADMIN',
]

export const SUPPORT_VC_AUDIT_VIEW_ROLES = [
  'ROLE_VC_AUDIT_ADMIN',
  'ROLE_VC_AUDIT_MANAGER',
]

export const SUPPORT_BOOKING_RECORDING_PREFERENCE_ROLES = [
  'ROLE_THERAPY_SUP_L3',
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_CLINIC_SUCCESS_MANAGER',
  'ROLE_ADMIN',
]

export const SUPPORT_BOOKING_INVOICE_ROLES = [
  'ROLE_THERAPY_SUP_L2',
  'ROLE_THERAPY_SUP_L3',
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_CLINIC_SUCCESS_MANAGER',
  'ROLE_ADMIN',
]

export const SUPPORT_CASE_DISPATCH_ROLES = [
  'ROLE_THERAPY_SUP_L2',
  'ROLE_THERAPY_SUP_L3',
  'ROLE_THERAPIST_SUPERVISOR',
  'ROLE_THERAPY_SUPERVISOR',
  'ROLE_SCREENER_SUPERVISOR',
  'ROLE_CLINIC_SUCCESS_MANAGER',
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_ADMIN',
]

export const SUPPORT_CUSTOM_COMMUNICATIONS_VIEW_ROLES = ['ROLE_MANAGEMENT']

export const SUPPORT_PRESCRIPTION_REPORT_VIEW_ROLES = [
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_CLINIC_SUCCESS_MANAGER',
  'ROLE_ADMIN',
]

export const SUPPORT_THERAPY_REPORT_VIEW_ROLES = [
  'ROLE_THERAPIST_SUPERVISOR',
  'ROLE_THERAPY_SUPERVISOR',
  'ROLE_ADMIN',
]

export const SUPPORT_SCREENING_REPORT_VIEW_ROLES = [
  'ROLE_THERAPY_SUP_L3',
  'ROLE_SCREENER_SUPERVISOR',
  'ROLE_ADMIN',
]

export const SUPPORT_ASSESSMENT_REPORT_VIEW_ROLES = [
  'ROLE_THERAPY_SUP_L3',
  'ROLE_THERAPY_SUPERVISOR',
  'ROLE_ADMIN',
]

export const SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_THERAPY = [
  { id: 'screening', title: 'Screening' },
  { id: 'therapy-session', title: 'Therapy Session' },
  { id: 'assessment', title: 'Assessment' },
]

export const SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_THERAPIST_SUPERVISOR = [
  { id: 'therapy-session', title: 'Therapy Session' },
]

export const SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_THERAPY_SUPERVISOR = [
  { id: 'therapy-session', title: 'Therapy Session' },
  { id: 'assessment', title: 'Assessment' },
]

export const SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_SCREENER_SUPERVISOR = [
  { id: 'screening', title: 'Screening' },
]

export const SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_CLINIC_SUCCESS = [
  { id: 'consultation', title: 'Consultation' },
  ...SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_THERAPY,
]

export const SUPPORT_REPORT_ACCESS_RULES = {
  consultation: {
    reportType: 'prescription',
    title: 'Prescription',
    allowedRoles: SUPPORT_PRESCRIPTION_REPORT_VIEW_ROLES,
  },
  'nutrition-consultation': {
    reportType: 'therapy-report',
    title: 'Therapy Report',
    allowedRoles: SUPPORT_THERAPY_REPORT_VIEW_ROLES,
  },
  'therapy-session': {
    reportType: 'therapy-report',
    title: 'Therapy Report',
    allowedRoles: SUPPORT_THERAPY_REPORT_VIEW_ROLES,
  },
  screening: {
    reportType: 'screening-report',
    title: 'Screening Report',
    allowedRoles: SUPPORT_SCREENING_REPORT_VIEW_ROLES,
  },
  assessment: {
    reportType: 'assessment-report',
    title: 'Assessment Report',
    allowedRoles: SUPPORT_ASSESSMENT_REPORT_VIEW_ROLES,
  },
}

export const SUPPORT_BOOKING_REPORT_VIEW_ROLES = [
  ...new Set(
    Object.values(SUPPORT_REPORT_ACCESS_RULES).flatMap((rule) => rule.allowedRoles || []),
  ),
]

export const SUPPORT_ACCESS_MATRIX = [
  {
    section: 'Practitioners & Service Providers',
    rows: [
      {
        label: 'Therapists',
        roles: [
          'ROLE_THERAPY_SUP_L1',
          'ROLE_THERAPY_SUP_L2',
          'ROLE_THERAPY_SUP_L3',
          'ROLE_THERAPIST_ADMIN',
        ],
      },
      {
        label: 'Applicants picker (Doctor / Therapist / Screener / Uncategorized tiles)',
        roles: [
          'ROLE_THERAPY_SUP_L1',
          'ROLE_THERAPY_SUP_L2',
          'ROLE_THERAPY_SUP_L3',
          'ROLE_THERAPIST_ADMIN',
        ],
      },
      {
        label: 'Applicants > Doctor / Therapist / Screener / Uncategorized listing',
        roles: [
          'ROLE_THERAPY_SUP_L1',
          'ROLE_THERAPY_SUP_L2',
          'ROLE_THERAPY_SUP_L3',
          'ROLE_THERAPIST_ADMIN',
        ],
      },
      {
        label: 'Applicants > Approve action',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_ADMIN'],
      },
      {
        label: 'Screeners (by target specialty / No specialty)',
        roles: [
          'ROLE_THERAPY_SUP_L1',
          'ROLE_THERAPY_SUP_L2',
          'ROLE_THERAPY_SUP_L3',
          'ROLE_THERAPIST_ADMIN',
        ],
      },
      {
        label: 'Therapist Payout Reports',
        roles: ['ROLE_THERAPIST_ADMIN'],
      },
      {
        label: 'Doctors',
        roles: ['ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_CLINIC_SUCCESS_MANAGER'],
      },
      {
        label: 'Practitioner Invitations (generate / list / revoke token-gated apply links)',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_ADMIN'],
      },
      {
        label: 'Practitioner Onboarding (Doctor / Therapist / Screener type picker)',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN'],
      },
      {
        label: 'Practitioner Onboarding > Doctor / Therapist / Screener form',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN'],
      },
      {
        label: 'Practitioner Onboarding > Auditor Access (sub-route)',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN'],
      },
      {
        label: 'Practitioner Onboarding > Payment Configuration (inline + sub-route)',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN'],
      },
      {
        label: 'Practitioner Onboarding > Engagement Model preview + inline editor',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_ADMIN'],
      },
      {
        label: 'Practitioner Onboarding > Email/Mobile offline-verify (auditable)',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_ADMIN'],
      },
      {
        label: 'Service Approvals',
        roles: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3', 'ROLE_CLINIC_SUCCESS_ADMIN'],
      },
      {
        label: 'Service Approvals > Doctor tab',
        roles: ['ROLE_CLINIC_SUCCESS_ADMIN'],
      },
      {
        label: 'Service Approvals > Therapist tab',
        roles: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
      },
      {
        label: 'Service Approvals > Screener tab',
        roles: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
      },
      {
        label: 'Service Approvals > Content Creators tab',
        roles: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
      },
      {
        label: 'Service Approvals > 1-on-1 Unapproved tab',
        roles: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
      },
      {
        label: 'Service Approvals > Approve/Disapprove/Re-KYC as Doctor',
        roles: ['ROLE_CLINIC_SUCCESS_ADMIN'],
      },
      {
        label: 'Service Approvals > Approve/Disapprove as Therapist or Screener',
        roles: ['ROLE_THERAPY_SUP_L3'],
      },
      {
        label: 'Audit Requests',
        roles: ['ROLE_THERAPY_SUP_L3', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_CLINIC_SUCCESS_MANAGER'],
      },
      {
        label: 'Practitioner enable / disable control (detail page)',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_ADMIN'],
      },
      {
        label: 'Practitioner Access Logs (global + per-practitioner trail)',
        roles: ['ROLE_THERAPIST_ADMIN', 'ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_ADMIN'],
      },
    ],
  },
  {
    section: 'Clinics & Hospitals',
    rows: [
      {
        label: 'Clinics',
        roles: ['ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_CLINIC_SUCCESS_MANAGER'],
      },
      {
        label: 'Clinics > Specialty tabs (Psychiatry / Endocrinology / … / Not set)',
        roles: ['ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_CLINIC_SUCCESS_MANAGER'],
      },
      {
        label: 'Clinic Roster',
        roles: ['ROLE_CLINIC_ROSTER_MANAGER', 'ROLE_CLINIC_ROSTER_ADMIN'],
      },
      {
        label: 'Clinic Brand Invoices',
        roles: ['ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_CLINIC_SUCCESS_MANAGER'],
      },
    ],
  },
  {
    section: 'Important Actions',
    rows: [
      {
        label: 'Interventions Requested',
        roles: [
          'ROLE_THERAPY_SUP_L2',
          'ROLE_THERAPY_SUP_L3',
          'ROLE_CLINIC_SUCCESS_ADMIN',
          'ROLE_CLINIC_SUCCESS_MANAGER',
        ],
      },
      {
        label: 'Interventions Requested > Doctor actions',
        roles: ['ROLE_CLINIC_SUCCESS_ADMIN', 'ROLE_CLINIC_SUCCESS_MANAGER'],
      },
      {
        label: 'Bookings & Appointments',
        roles: [...SUPPORT_BOOKINGS_VIEW_ROLES, ...SUPPORT_VC_AUDIT_VIEW_ROLES],
      },
      {
        label: 'Bookings & Appointments > Prescription report',
        roles: [...SUPPORT_PRESCRIPTION_REPORT_VIEW_ROLES],
      },
      {
        label: 'Bookings & Appointments > Therapy report',
        roles: [...SUPPORT_THERAPY_REPORT_VIEW_ROLES],
      },
      {
        label: 'Bookings & Appointments > Screening report',
        roles: [...SUPPORT_SCREENING_REPORT_VIEW_ROLES],
      },
      {
        label: 'Bookings & Appointments > Assessment report',
        roles: [...SUPPORT_ASSESSMENT_REPORT_VIEW_ROLES],
      },
      {
        label: 'Bookings & Appointments > Any report view button',
        roles: [...SUPPORT_BOOKING_REPORT_VIEW_ROLES],
      },
      {
        label: 'Bookings & Appointments > Generate / send invoice',
        roles: [...SUPPORT_BOOKING_INVOICE_ROLES],
      },
      {
        label: 'Bookings & Appointments > Session media live / recordings',
        roles: [...SUPPORT_VC_AUDIT_VIEW_ROLES],
      },
      {
        label: 'Bookings & Appointments > Recording preference',
        roles: [...SUPPORT_BOOKING_RECORDING_PREFERENCE_ROLES],
      },
      {
        label: 'Payment Links',
        roles: [...SUPPORT_PAYMENT_LINKS_VIEW_ROLES],
      },
      {
        label: 'Overall Roster',
        roles: ['ROLE_CLINIC_ROSTER_MANAGER', 'ROLE_CLINIC_ROSTER_ADMIN'],
      },
      {
        label: 'DocSide',
        roles: ['ROLE_DOCSIDE_ADMIN'],
      },
      {
        label: 'Custom Communications',
        roles: [...SUPPORT_CUSTOM_COMMUNICATIONS_VIEW_ROLES],
      },
    ],
  },
  {
    section: 'Management Reporting',
    rows: [
      {
        label: 'Bookings',
        roles: ['ROLE_MANAGEMENT'],
      },
    ],
  },
]

export const SERVICE_APPROVAL_TAB_ACCESS = {
  doctors: ['ROLE_CLINIC_SUCCESS_ADMIN'],
  therapists: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
  screeners: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
  contentCreators: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
  unapproved: ['ROLE_THERAPY_SUP_L2', 'ROLE_THERAPY_SUP_L3'],
}

export const SERVICE_APPROVAL_ACTION_ACCESS = {
  ROLE_DOCTOR: ['ROLE_CLINIC_SUCCESS_ADMIN'],
  ROLE_THERAPIST: ['ROLE_THERAPY_SUP_L3'],
  ROLE_SCREENER: ['ROLE_THERAPY_SUP_L3'],
}

export const SUPPORT_ACCESS_MATRIX_ADMIN_ROLES = [
  'ROLE_THERAPIST_ADMIN',
  'ROLE_CLINIC_SUCCESS_ADMIN',
  'ROLE_CLINIC_ROSTER_ADMIN',
  'ROLE_VC_AUDIT_ADMIN',
  'ROLE_DOCSIDE_ADMIN',
]

export function formatSupportRoleNames(roleIds = []) {
  return roleIds
    .map((roleId) => SUPPORT_ROLE_LABELS[roleId] || roleId)
    .join(', ')
}

export function hasAnySupportRole(userRoles = [], requiredRoles = []) {
  if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
    return true
  }
  if (!Array.isArray(userRoles) || userRoles.length === 0) {
    return false
  }
  return requiredRoles.some((roleId) => userRoles.includes(roleId))
}

export function hasSupportAccessMatrixAccess(userRoles = []) {
  return hasAnySupportRole(userRoles, SUPPORT_ACCESS_MATRIX_ADMIN_ROLES)
}

export function canViewSupportBookings(userRoles = []) {
  return hasAnySupportRole(userRoles, SUPPORT_BOOKINGS_VIEW_ROLES)
}

export function canRescheduleSupportBookedEvent(userRoles = [], eventType) {
  if (hasAnySupportRole(userRoles, ['ROLE_ADMIN'])) {
    return true
  }

  const consultationEventTypes = ['consultation', 'nutrition-consultation']
  if (consultationEventTypes.includes(eventType)) {
    return hasAnySupportRole(userRoles, SUPPORT_BOOKING_ACTION_CONSULTATION_ROLES)
  }

  return hasAnySupportRole(userRoles, SUPPORT_BOOKING_ACTION_THERAPY_ROLES)
}

export function canViewSupportVcAuditBookings(userRoles = []) {
  return hasAnySupportRole(userRoles, SUPPORT_VC_AUDIT_VIEW_ROLES)
}

export function canViewSupportPaymentLinks(userRoles = []) {
  return hasAnySupportRole(userRoles, SUPPORT_PAYMENT_LINKS_VIEW_ROLES)
}

export function canViewSupportCustomCommunications(userRoles = []) {
  return hasAnySupportRole(userRoles, SUPPORT_CUSTOM_COMMUNICATIONS_VIEW_ROLES)
}

export function canManageSupportRecordingPreferences(userRoles = []) {
  return hasAnySupportRole(userRoles, SUPPORT_BOOKING_RECORDING_PREFERENCE_ROLES)
}

export function canManageSupportBookedEventInvoices(userRoles = []) {
  return hasAnySupportRole(userRoles, SUPPORT_BOOKING_INVOICE_ROLES)
}

export function getAllowedSupportBookedEventTypeOptions(userRoles = []) {
  const hasClinicSuccessAccess = hasAnySupportRole(
    userRoles,
    SUPPORT_BOOKINGS_CLINIC_SUCCESS_ROLES,
  )
  const hasTherapyAccess = hasAnySupportRole(userRoles, SUPPORT_BOOKINGS_THERAPY_ROLES)
  const hasTherapistSupervisorAccess = hasAnySupportRole(userRoles, ['ROLE_THERAPIST_SUPERVISOR'])
  const hasTherapySupervisorAccess = hasAnySupportRole(userRoles, ['ROLE_THERAPY_SUPERVISOR'])
  const hasScreenerSupervisorAccess = hasAnySupportRole(userRoles, ['ROLE_SCREENER_SUPERVISOR'])
  const hasAdminAccess = hasAnySupportRole(userRoles, ['ROLE_ADMIN'])

  if (hasAdminAccess || hasClinicSuccessAccess) {
    return SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_CLINIC_SUCCESS
  }

  const mergedOptions = []
  const appendOptions = (options = []) => {
    options.forEach((option) => {
      if (!mergedOptions.some((existing) => existing.id === option.id)) {
        mergedOptions.push(option)
      }
    })
  }

  if (hasTherapyAccess) {
    appendOptions(SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_THERAPY)
  }
  if (hasTherapistSupervisorAccess) {
    appendOptions(SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_THERAPIST_SUPERVISOR)
  }
  if (hasTherapySupervisorAccess) {
    appendOptions(SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_THERAPY_SUPERVISOR)
  }
  if (hasScreenerSupervisorAccess) {
    appendOptions(SUPPORT_BOOKED_EVENT_TYPE_OPTIONS_SCREENER_SUPERVISOR)
  }

  if (mergedOptions.length > 0) {
    return mergedOptions
  }

  return []
}

export function getSupportReportAccessConfig(eventType) {
  if (!eventType) {
    return null
  }
  return SUPPORT_REPORT_ACCESS_RULES[eventType] || null
}

export function canViewSupportReportForEventType(userRoles = [], eventType) {
  const config = getSupportReportAccessConfig(eventType)
  if (!config) {
    return false
  }
  return hasAnySupportRole(userRoles, config.allowedRoles)
}

export function getAllowedSupportReportRolesForEventType(eventType) {
  const config = getSupportReportAccessConfig(eventType)
  return config?.allowedRoles || []
}
